import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';
import { Collapsable } from '../../../Collapsable';

interface ContainerFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function ContainerFeatureTogglesView({ company, update }: ContainerFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.containers;

  return (
    <Collapsable
      open={toggles.containers}
      header={
        <FeatureToggleItem
          value={toggles.containers}
          onChange={async value => await update(copy.withContainersFeatureToggle(value))}
        >
          <FeatureToggleTitle text={t(TranslationKey.containerContainerFeatureToggleTitle).singular.upper} />
          <FeatureToggleExplanation
            text={t(TranslationKey.containerContainerFeatureToggleExplanation).singular.upper}
          />
          <FeatureToggleInformation
            text={t(TranslationKey.containerContainerFeatureToggleInformation).singular.upper}
          />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.allowBinMismatch}
        onChange={async value => await update(copy.withContainersAllowBinMismatchFeatureToggle(value))}
      >
        <FeatureToggleTitle
          text={t(TranslationKey.containerContainerAllowBinMismatchFeatureToggleTitle).singular.upper}
        />
        <FeatureToggleExplanation
          text={t(TranslationKey.containerContainerAllowBinMismatchFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
    </Collapsable>
  );
}
